import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";

/**
 * Fetches channel details by ID.
 * Returns a generic record by default; consumers can narrow
 * with their own channel type via `data as ChannelDetails`.
 */
export function useChannelDetails(channelId) {
  const $ = _c(11);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== channelId) {
    t0 = [...QUERY_KEYS.channelDetails(channelId)];
    $[0] = channelId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== apiFetcher || $[3] !== channelId) {
    t1 = () => apiFetcher(`/api/v1/chat/channels/${channelId}`);
    $[2] = apiFetcher;
    $[3] = channelId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== channelId) {
    t2 = !!channelId && channelId.trim() !== "";
    $[5] = channelId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      refetchInterval: 30000,
      staleTime: 20000,
      gcTime: 300000
    };
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return useQuery(t3);
}